<template>
  <div>
    <div class="fxd .f -z-n">
      <img style="object-fit: cover;" class="abs .f " src="~@/assets/bg.png">
    </div>
    <HeaderPart></HeaderPart>
    <Container>
      <div class="rlt">
        <div class="a-c">
          <SwingTitle>{{ $t('Embed Widgets') }}</SwingTitle>
          <p class="o-5">{{ $t('Embed widgets on your site') }}</p>
        </div>
        <div class="p-6 font-en">
          <p class="c5-t">{{ $t("You can use these widgets to embed statistics in your blog or website") }}</p>
          <div class="#8 m:#7 l:#6 p-y-5 Case">{{ $t("usage") }}</div>
          <p class="c5-t m-y-4">{{ $t("it was easy to use as you'll see!") }}</p>
          <div class="s#1 p-y-4 c-ylw b b-c c-0-t">
            <i class="material-icons m-s-5">info</i>
            <div class=" m-x-4">{{ $t("only widget param important") }}</div>
          </div>
          <div>
            <p class="c5-t m-y-2">Summary widget:</p>
            <div style="--el-u: 0;--el-p: 0;" class="-b-1 b c19-b -o-h l20 d4 -r-l">
              <pre class="x6 p-5 m-n c5 c12-t #11">&lt;iframe src="<span class="c20-t">{{baseURI}}widgets/widget?group=<span class="c-rd-t">africa</span>&amp;widget=<span class="c-rd-t">summary</span></span>" height="150" frameborder="0"&gt;&lt;/iframe&gt;</pre>
              <iframe class="x6" :src="baseURI+'widgets/widget?group=africa&amp;widget=summary'" width="560" height="200" frameborder="0"></iframe>
            </div>
          </div>
          <div>
            <p class="c5-t m-y-2">Default widget:</p>
            <div style="--el-u: 0;--el-p: 0;" class="-b-1 b c19-b -o-h l20 d4 -r-l">
              <pre class="x6 p-5 m-n c5 c12-t #11">&lt;iframe src="<span class="c20-t">{{baseURI}}widgets/widget?country=<span class="c-bl-t">DZ</span>&amp;widget=<span class="c-rd-t">default</span></span>" height="150" frameborder="0"&gt;&lt;/iframe&gt;</pre>
              <iframe class="x6" :src="baseURI+'widgets/widget?widget=defaults'" width="560" height="450" frameborder="0"></iframe>
            </div>
          </div><div>
            <p class="c5-t m-y-2">Details widget:</p>
            <div style="--el-u: 0;--el-p: 0;" class="-b-1 b c19-b -o-h l20 d4 -r-l">
              <pre class="x6 p-5 m-n c5 c12-t #11">&lt;iframe src="<span class="c20-t">{{baseURI}}widgets/widget?country=<span class="c-bl-t">DZ</span>&amp;widget=<span class="c-rd-t">details</span></span>" height="150" frameborder="0"&gt;&lt;/iframe&gt;</pre>
              <iframe class="x6" :src="baseURI+'widgets/widget?country=DZ&amp;widget=details'" width="560" height="146" frameborder="0"></iframe>
            </div>
          </div>
          <div>
            <p class="c5-t m-y-2">List widget:</p>
            <div style="--el-u: 0;--el-p: 0;" class="-b-1 b c19-b -o-h l20 d4 -r-l">
              <pre class="x6 p-5 m-n c5 c12-t #11">&lt;iframe src="<span class="c20-t">{{baseURI}}widgets/widget?country=<span class="c-bl-t">DZ</span>&amp;widget=<span class="c-rd-t">list</span></span>" height="150" frameborder="0"&gt;&lt;/iframe&gt;</pre>
              <iframe class="x6" :src="baseURI+'widgets/widget?country=DZ&amp;widget=List'" width="560" height="250" frameborder="0"></iframe>
            </div>
          </div>
          <div>
            <p class="c5-t m-y-2">Chart widget:</p>
            <div style="--el-u: 0;--el-p: 0;" class="-b-1 b c19-b -o-h l20 d4 -r-l">
              <pre class="x6 p-5 m-n c5 c12-t #11">&lt;iframe src="<span class="c20-t">{{baseURI}}widgets/widget?country=<span class="c-bl-t">DZ</span>&amp;widget=<span class="c-rd-t">chart</span></span>" height="150" frameborder="0"&gt;&lt;/iframe&gt;</pre>
              <iframe class="x6" :src="baseURI+'widgets/widget?country=DZ&amp;widget=chart'" width="560" height="350" frameborder="0"></iframe>
            </div>
          </div>
          <div>
            <p class="c5-t m-y-2">Posts widget:</p>
            <div style="--el-u: 0;--el-p: 0;" class="-b-1 b c19-b -o-h l20 d4 -r-l">
              <pre class="x6 p-5 m-n c5 c12-t #11">&lt;iframe src="<span class="c20-t">{{baseURI}}widgets/widget?country=<span class="c-bl-t">DZ</span>&amp;widget=<span class="c-rd-t">posts</span></span>" height="150" frameborder="0"&gt;&lt;/iframe&gt;</pre>
              <iframe class="x6" :src="baseURI+'widgets/widget?country=DZ&amp;widget=posts'" width="560" height="350" frameborder="0"></iframe>
            </div>
          </div>
          <div class="#8 m:#7 l:#6 p-y-5">URL Params</div>
          <p class="c5-t"><span class="c-rd-t">*</span> {{ $t("important") }}</p>
          <div class="-o-a">
            <table>
              <tbody>
                <tr class="CASE">
                  <th>parameters</th>
                  <th>Options</th>
                </tr>
                <tr>
                  <td>locale</td>
                  <td>
                    <pre class="c# m-n">language: ar, en</pre>
                  </td>
                </tr>
                <tr>
                  <td>widget</td>
                  <td>
                    <pre class="c# m-n">mix, summary, list, details, chart, posts</pre>
                  </td>
                </tr>
                <tr>
                  <td>country</td>
                  <td>
                    <pre class="c# m-n">country code: DZ, TN ...</pre>
                  </td>
                </tr>
                <tr>
                  <td>group</td>
                  <td>
                    <pre class="c# m-n">countries groups: world, arabs, africa, asia, europe, oceania, northAmerica, southAmerica, antarctica</pre>
                  </td>
                </tr>
                <tr>
                  <td>style</td>
                  <td>
                    <pre class="c# m-n">card, border, none</pre>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
// Widgets
import SwingTitle from '../components/SwingTitle'
// import SummaryWidget from '../widgets/Summary'
// import ListWidget from '../widgets/List'
// import DetailsWidget from '../widgets/Details'
// import ChartWidget from '../widgets/Chart'
// import PostsWidget from '../widgets/Posts'
// Parts
import HeaderPart from '../parts/header'
// Components
import Container from '../components/physia/Container'

export default {
  name: 'Home',
  components: {
    // SummaryWidget,
    // ListWidget,
    // DetailsWidget,
    // ChartWidget,
    // PostsWidget,
    Container,
    SwingTitle,
    HeaderPart
  },
  computed: {
    ...mapState(['countries', 'countriesData', 'selectedCountry']),
    ...mapGetters(['getSelectedCountries', 'isMedia'])
  },
  data () {
    return {
      baseURI: document.head.baseURI,
      loadingPosts: true,
      orderArabCountriesBy: 'cases',
      countryCard: null,
      country: 0,
      countryPanelOpen: 0,
      chartData: {
        labels: [],
        datasets: []
      },
      chartOptions: {
        title: {
          display: true,
          text: 'DATA CENTER'
        }
      },
      chartStyles: {
        height: '300px',
        width: '100%',
        position: 'relative'
      }
    }
  },
  watch: {
    selectedCountry (newValue, oldValue) {
      this.countryPanelOpen = 1
    },
    countryPanelOpen (newValue, oldValue) {
      if (newValue && (this.$store.getters.isMedia('s') || this.$store.getters.isMedia('m'))) {
        document.scrollingElement.classList.add('-o-h', 'scrolling-element')
      } else {
        if (document.querySelector('.scrolling-element')) {
          document.querySelector('.scrolling-element').classList.remove('-o-h', 'scrolling-element')
        }
      }
    }
  }
}
</script>
